    <kendo-autocomplete
        [data]="conseillers"
        [filterable]="true"
        [valueField]="'fullName'"
        (valueChange)="onValueChange($event)"
        (filterChange)="handleFilter($event)"
        [disabled]="disabled"
    >
    </kendo-autocomplete>